import {CategoryHighlightSection_Element} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  originClick,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions, useTrackOriginClick} from '@aboutyou/tracking';
import {CardImage, COLORS, UnstyledLink} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useState} from 'react';
import {useHistory} from 'react-router';
import {buildFirstProductIdsQueryParam} from '../../../../features/firstProductId/useFirstProductIds';
import {CategoryHighlightSectionProductList} from './CategoryHighlightSectionProductList/CategoryHighlightSectionProductList';

export const CategoryHighlightSectionCard: React.FC<{
  element: CategoryHighlightSection_Element;
  streamPosition: number;
  horizontalPosition: number;
}> = ({element, streamPosition, horizontalPosition}) => {
  const {t} = useTranslation();
  const trackOriginClick = useTrackOriginClick();
  const [cardProductIds, setCardProductIds] = useState<number[]>([]);
  const history = useHistory();
  const cardUrl = `${
    element.link.linkTarget.url
  }${buildFirstProductIdsQueryParam(cardProductIds)}`;

  const onCardClick = (event: React.MouseEvent) => {
    event.preventDefault();
    if (element.promotionTracker.locationId) {
      trackOriginClick(element.promotionTracker.locationId as originClick)();
    }
    history.push(cardUrl);
  };

  const onProductListClick = (event: React.MouseEvent) => {
    event.preventDefault();
    history.push(cardUrl);
  };

  return (
    <CategoryCard
      streamPosition={streamPosition}
      promotion={{
        source: TrackingPromotionCreative.GenericPromotion,
        promotionTracker: {...element.promotionTracker, destination: cardUrl},
      }}
      horizontalPosition={horizontalPosition}
      triggerOnce
    >
      <StyledCardImage
        data-testid="categoryHighlightSectionCard"
        image={element.coverSquareImage}
        imageRatio="1:1"
        breakpoints={[]}
        widths={[295, 590]}
        cta={{label: element.link.label, url: element.link.linkTarget.url}}
        onClick={onCardClick}
        ctaSize="full-width"
      />
      <ProductListWrapper
        onClick={onProductListClick}
        to={element.link.linkTarget.url}
        aria-label={t('Products')}
      >
        <CategoryHighlightSectionProductList
          content={element.content}
          setCardProductIds={setCardProductIds}
        />
      </ProductListWrapper>
    </CategoryCard>
  );
};

const CategoryCard = styled(TrackPromotions)`
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid ${COLORS['Outline.Grey']};
  border-radius: 8px;
  overflow: hidden;
`;

const StyledCardImage = styled(CardImage)`
  &&& {
    border-radius: 0;
  }
`;

const ProductListWrapper = styled(UnstyledLink)`
  padding-top: 2px;
`;
